@if (pwaInstallService.bannerVisible$ | async) {
  <app-install-pwa-prompt />
}
@if (freshChatService.shouldShowLauncher && !(freshChatService.open$ | async)) {
  <button
    type="button"
    class="freshchat-launcher btn btn-primary rounded-circle border-0 shadow d-flex align-items-center justify-content-center p-0 text-white position-fixed"
    (click)="openFreshChatLauncher($event)"
    aria-label="Open live chat"
  >
    <i class="bi bi-chat-dots-fill fs-4" aria-hidden="true"></i>
  </button>
}
@if (chatClientService.isEnabled) {
  <app-chat-client-panel />
}
@if (!isSiteUnderMaintenance) {
  <router-outlet></router-outlet>
}
@if (isSiteUnderMaintenance) {
  <div>
    <temporarily-unavailable></temporarily-unavailable>
  </div>
}
